import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
    verifyUserOTP,
    
} from '../../services/AuthService';
import {formatSuccess} from '../../services/commonServices';
// import {loadProfile} from './ProfileAction'
export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const REFRESH_ACCESS_TOKEN = '[refresh access token] refresh access token';
export function signupAction(fromData, navigate) {
    return (dispatch) => {
        signUp(fromData)
        .then((response) => {
            dispatch(confirmedSignupAction(response.data.data));
            formatSuccess('Merchant Registration',response.data)
        })
        .catch((error) => {
            console.error('signup error', error);
            const errorData = error?.response?.data || { message: error.message || 'Unknown signup error' };
            const errorMessage = formatError(errorData);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}


export async function verifyOTP(formData) {
    try {
        const response = await verifyUserOTP(formData);
        return {
            success: true,
            data: response.data.data,
        };
    } catch (error) {
        const errorMessage = formatError(error?.response?.data || error.message);
        return {
            success: false,
            error: errorMessage,
        };
    }
}
export function Logout(navigate) {
	localStorage.removeItem('userDetails');
    navigate('/login');
	return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(payload, navigate) {
    return (dispatch) => {
         login(payload)
            .then((response) => { 
                const expiryDate = new Date();
                saveTokenInLocalStorage(response.data.data, {
                    ...response.data.data,  
                    ...{expireDate : expiryDate.setDate(expiryDate.getDate() + 7)}
                });
                runLogoutTimer(
                    dispatch,
                    7 * 24 * 60 * 60 * 1000,
                    navigate,
                );
                dispatch(loginConfirmedAction(response.data.data));               
			    navigate('/dashboard');                
            })
            .catch((error) => {
                const errorMessage = formatError(error.response.data);
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function refreshAccessToken(payload){
    let getLocalData = localStorage.getItem('userDetails')
    if(getLocalData){
        getLocalData = JSON.parse(getLocalData)
        getLocalData.accessToken = payload
        localStorage.setItem('userDetails', JSON.stringify(getLocalData))
    }
    return {
        type: REFRESH_ACCESS_TOKEN,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
